import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["data", "columns", "loading", "disableRow", "noDataMessage", "verticalScrollingParent", "pageSize", "recordAttributeIdentifier", "order", "rowActions", "rowActionsType", "bulkActions", "unselectableRowCondition", "hideActionBar", "onRowClick", "onOrderChange", "onSelectionChange"];
import React from 'react';
import { RowActionType } from '../../Table.decl';
import { TableRoot } from '../TableRoot/TableRoot';
import { TableInner } from './TableInner';

var WrappedTable = function WrappedTable(_ref, ref) {
  var data = _ref.data,
      columns = _ref.columns,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      disableRow = _ref.disableRow,
      noDataMessage = _ref.noDataMessage,
      verticalScrollingParent = _ref.verticalScrollingParent,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 50 : _ref$pageSize,
      _ref$recordAttributeI = _ref.recordAttributeIdentifier,
      recordAttributeIdentifier = _ref$recordAttributeI === void 0 ? 'id' : _ref$recordAttributeI,
      order = _ref.order,
      rowActions = _ref.rowActions,
      _ref$rowActionsType = _ref.rowActionsType,
      rowActionsType = _ref$rowActionsType === void 0 ? RowActionType.Dropdown : _ref$rowActionsType,
      bulkActions = _ref.bulkActions,
      unselectableRowCondition = _ref.unselectableRowCondition,
      hideActionBar = _ref.hideActionBar,
      onRowClick = _ref.onRowClick,
      onOrderChange = _ref.onOrderChange,
      onSelectionChange = _ref.onSelectionChange,
      styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TableRoot, _extends({
    loading: loading,
    recordAttributeIdentifier: recordAttributeIdentifier
  }, styleProps), /*#__PURE__*/React.createElement(TableInner, {
    ref: ref,
    data: data,
    columns: columns,
    disableRow: disableRow,
    noDataMessage: noDataMessage,
    verticalScrollingParent: verticalScrollingParent,
    pageSize: pageSize,
    order: order,
    rowActions: rowActions,
    rowActionsType: rowActionsType,
    bulkActions: bulkActions,
    unselectableRowCondition: unselectableRowCondition,
    hideActionBar: hideActionBar,
    onRowClick: onRowClick,
    onOrderChange: onOrderChange,
    onSelectionChange: onSelectionChange
  }));
};

export var Table = /*#__PURE__*/React.forwardRef(WrappedTable);
export default Table;